import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {WorkflowDetailClientService} from '../dialog/workflow-detail-dialog/workflow-detail-client.service';
import {UnsubscribeBaseComponent} from '../unsubscribe-base.component';
import {takeUntil} from 'rxjs';
import {animate, style, transition, trigger, AnimationEvent} from '@angular/animations';
import {InputTextAreaComponent} from '../input/text-area/input-text-area.component';

@Component({
  selector: 'app-workflow-step-comment',
  templateUrl: './workflow-step-comment.component.html',
  styleUrls: ['./workflow-step-comment.component.scss'],
  animations: [
    trigger('expandCollapse', [
      transition(':enter', [
        style({ height: '0', opacity: 0, overflow: 'hidden' }),
        animate('250ms ease-out', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('200ms ease-in', style({ height: '0', opacity: 0 }))
      ])
    ])
  ]
})
export class WorkflowStepCommentComponent extends UnsubscribeBaseComponent implements OnInit, OnDestroy {

  @Input() readOnly = false;
  @ViewChild('commentInput') commentInput?: InputTextAreaComponent;
  comment: string = '';
  isEditing = false;
  showDisplay = true;

  constructor(public workflowDetailClientService: WorkflowDetailClientService) {
    super();
  }

  ngOnInit(): void {
    this.workflowDetailClientService.selectedStep$
      .pipe(takeUntil(this.unSubscribe))
      .subscribe(step => {
        this.comment = step?.comment?.comment ?? '';
        this.isEditing = false;
        this.showDisplay = true;
      });
  }

  toggleEdit() {
    if (!this.isEditing) {
      // Opening editor: hide read-only immediately
      this.showDisplay = false;
      this.isEditing = true;
      if (!this.readOnly) {
        setTimeout(() => this.commentInput?.focus());
      }
    } else {
      // Closing editor via toggle -> save and let animation finish before showing read-only
      this.saveComment();
    }
  }

  saveComment() {
    const currentStep = this.workflowDetailClientService.selectedStep$.getValue();
    if (currentStep && !this.readOnly) {
      if (!currentStep.comment) {
        currentStep.comment = { comment: this.comment };
      } else {
        currentStep.comment.comment = this.comment;
      }
      this.workflowDetailClientService.silentSave();
    }
    // Trigger collapse animation; read-only view will appear on animation done
    this.isEditing = false;
  }

  onEditAnimationDone(event: AnimationEvent) {
    // When edit container finished leaving (collapsed), show the read-only view
    if (event.toState === 'void') {
      this.showDisplay = true;
    }
  }

  onCommentChange(newValue: string) {
    this.comment = newValue;
    const currentStep = this.workflowDetailClientService.selectedStep$.getValue();
    if (currentStep && !this.readOnly) {
      if (!currentStep.comment) {
        currentStep.comment = {comment: this.comment};
      } else {
        currentStep.comment.comment = this.comment;
      }
    }
  }

  commentStripped(maxChars: number) {
    return this.comment?.length > maxChars ? this.comment?.substring(0, maxChars) + '...' : this.comment;
  }

}
